<h2 mat-dialog-title>Ask Question</h2>
<mat-dialog-content class="mat-typography">
  <div>
    <div class="flex flex-row justify-between items-center p-4" [formGroup]="questionForm">
      <mat-form-field appearance="outline" class="mr-2 w-full">
        <mat-label>Question</mat-label>
        <textarea draggable="false" matInput rows="4" formControlName="question"></textarea>
      </mat-form-field>
    </div>
  </div>
</mat-dialog-content>
<mat-dialog-actions align="end" *ngIf="!busy">
  <button mat-raised-button mat-dialog-close *ngIf="!busy">Cancel</button>
  <button mat-raised-button color="primary" *ngIf="!busy" (click)="submitQuestion()" [disabled]="busy || !questionForm.valid">
    Submit
  </button>  <div class="m-8" *ngIf="busy">
    <mat-spinner diameter="20"></mat-spinner>
  </div>
</mat-dialog-actions>
